import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import styles from './react-table-skeleton.module.scss';
import useColumns from './useColumns';
import { useMemo } from 'react';


const ReactTableSkeleton = (props:any) => {
  const { recentPropertyColumns } = useColumns(props)
  const data = useMemo(() => [1, 2, 3, 4, 5, 6, 7, 8], []);
  const table = useReactTable({
    data: data,
    columns: recentPropertyColumns,
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <>
      <div className={styles.propertyTable}>
        <div className={styles.propertyColumn}>
          <div className={styles.columnWrap}>
            <table id='recentPropertyColumnsSkeleton'>
              <thead id='header'>
                {
                  table?.getHeaderGroups()?.map((headerGroup: any) => (
                    <tr key={headerGroup.id}>
                      {headerGroup?.headers?.map((header: any) => (
                        <th key={header.id} colSpan={header.colSpan}>
                          {!header.isPlaceholder && (
                            <div>
                              {flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                            </div>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
              </thead>
              <tbody>
                {
                  table?.getRowModel()?.rows?.map((row: any) => (
                    <tr
                      key={row.id}
                      tabIndex={0}
                    >
                      {row?.getAllCells()?.map((cell: any) => (
                        <td key={cell.id} >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      ))}

                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReactTableSkeleton;